import { Theme } from "@mui/material/styles";
//
import { CloseIcon } from "./CustomIcons";

// ----------------------------------------------------------------------

export default function Chip(theme: Theme) {
  return {
    MuiChip: {
      defaultProps: {
        deleteIcon: <CloseIcon />,
      },

      styleOverrides: {
        // eslint-disable-next-line no-empty-pattern
        root: ({}: { ownerState: { variant?: string; color?: string } }) => ({
          fontFamily: theme.typography.fontFamily,
          "&.MuiChip-sizeMedium > .MuiChip-avatar, .MuiChip-avatarSmall": {
            color: theme.palette.text.secondary,
          },
          variants: [{
            props: {
              variant: 'outlined'
            },
            style: {
              border: `1px solid ${theme.palette.grey[300]}`,
              backgroundColor: theme.palette.grey[50],
            }
          }, {
            props: {
              color: 'primary',
              variant: 'outlined'
            },
            style: {
              borderColor: theme.palette.primary.main,
            }
          }, {
            props: {
              color: 'secondary',
              variant: 'outlined'
            },
            style: {
              borderColor: theme.palette.secondary.main,
            }
          }, {
            props: {
              color: 'success',
              variant: 'filled'
            },
            style: {
              color: theme.palette.success.main,
              border: `1px solid ${theme.palette.success.main}`,
              backgroundColor: "#ECFDF3",
            }
          }, {
            props: {
              color: 'error',
              variant: 'filled'
            },
            style: {
              color: theme.palette.error.main,
              border: `1px solid #FECDCA`,
              backgroundColor: "#FEF3F2",
            }
          }, {
            props: {
              color: 'secondary',
              variant: 'filled'
            },
            style: {
              borderColor: theme.palette.secondary.main,
            }
          }]
        }),
        
        label: {
          fontFamily: theme.typography.fontFamily,
        },
        
        // eslint-disable-next-line no-empty-pattern
        avatar: ({}: { ownerState: { color?: string } }) => ({
          fontFamily: theme.typography.fontFamily,
          variants: [{
            props: {
              color: 'info'
            },
            style: {
              color: theme.palette.info.contrastText,
              backgroundColor: theme.palette.info.dark,
            }
          }, {
            props: {
              color: 'success'
            },
            style: {
              color: theme.palette.success.contrastText,
              backgroundColor: theme.palette.success.dark,
            }
          }, {
            props: {
              color: 'warning'
            },
            style: {
              color: theme.palette.warning.contrastText,
              backgroundColor: theme.palette.warning.dark,
            }
          }, {
            props: {
              color: 'error'
            },
            style: {
              color: theme.palette.error.contrastText,
              backgroundColor: theme.palette.error.dark,
            }
          }]
        }),
      },
    },
  };
}
